import { render, staticRenderFns } from "./MainCompressionForceSRelWidget.vue?vue&type=template&id=84e920d6&scoped=true&"
import script from "./MainCompressionForceSRelWidget.vue?vue&type=script&lang=ts&"
export * from "./MainCompressionForceSRelWidget.vue?vue&type=script&lang=ts&"
import style0 from "./MainCompressionForceSRelWidget.vue?vue&type=style&index=0&id=84e920d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e920d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSparkline } from 'vuetify/lib/components/VSparkline';
installComponents(component, {VCol,VRow,VSparkline})
